import TopImageTitleAndShortDescription from "~/components/topImageTitleAndShortDescription"

export default function pageTerms() {
  return (
    <div className="bg-[#FEFEFE]">
      <TopImageTitleAndShortDescription
        title="Terms of Use"
        shortDescription="Our agreement for using our services"
        textColor="black"
        image="./terms-of-use.jpeg"
        bg_color="#FFFFFF80"
      />
      <div
        className="container mx-auto max-w-5xl space-y-5 p-5 py-5 md:py-16"
        id="how-it-words">
        <p>October 2024</p>
        <p>
          Parties:
          <ul className="list-disc px-5">
            <li>
              Royal Government of Cambodia (RGC), represented by the Ministry of
              Environment (MoE), whose address is [Insert Address], Cambodia
              ("Cambodia Carbon Registry" or "CCR").
            </li>
            <li>You (User)</li>
          </ul>
        </p>

        <p>Recitals</p>
        <p>
          These Terms of Use set out the terms on which the Cambodia Carbon
          Registry offers to make the Cambodia Carbon Registry platform
          (Registry) available to the User. 
        </p>
        <p>
          The Registry serves as the national platform for registering and
          managing Green House Gas Emission Reduction (GHG ER) projects across
          Cambodia and facilitating the issuance, transfer, retirement, and
          cancellation of carbon credits. 
        </p>
        <p>
          The User wishes to use the Registry on the terms and conditions of
          this Agreement, as amended from time to time. Operative Provisions
        </p>
        <p className="font-bold">1. General Terms of Use</p>
        <p>
          1.1 The User acknowledges and agrees that when using the Cambodia
          Carbon Registry, the User will be subject to, and must comply with,
          these Terms of Use as modified from time to time in accordance with
          the terms hereof. 1.2 Where there is any inconsistency between these
          Terms of Use and the Program Rules and Requirements of the Cambodia
          Carbon Registry, the Program Rules and Requirements will prevail over
          these Terms of Use. 1.3 In addition, the User agrees to comply with
          any and all applicable regulations imposed and updated from time to
          time by a third-party regulator or authority designated by the Royal
          Government of Cambodia (RGC). 1.4 If the User does not agree to these
          Terms of Use, the User may not access or otherwise use the Cambodia
          Carbon Registry.
        </p>
        <p>Specified Business Activities</p>
        <p>
          1.5 The User may not conduct any of the following business activities
          in relation to its use of the Cambodia Carbon Registry without
          providing advance written notice to the MoE: 
          <br /> (a) purchasing, holding, transferring, retiring, or cancelling
          carbon credits on behalf of third parties; or  <br />
          (b) acting as an Agent on behalf of a Principal who owns or intends to
          own carbon credits. 1.6 Where the User conducts the business
          activities referred to in Clause 1.5, the User represents and warrants
          that:  <br />
          (a) in carrying out such business activities, it holds all necessary
          securities and/or financial services licenses and approvals required
          to undertake these activities in each of the jurisdictions in which it
          operates; 
          <br /> (b) where applicable, that Know-Your-Client checks have been
          conducted on each of the customers it is undertaking the business
          activities on behalf of; and 
          <br /> (c) if acting as an Agent, it has full, valid, and current
          authority to represent and act on behalf of the Principal (who shall
          be fully liable for the acts and omissions of the Agent) and that such
          authority has not been revoked. Related Instruments 1.9 The User may
          not conduct any of the following business activities without the
          express written consent of the MoE, which is to be granted in the
          MoE's sole and absolute discretion:  (a) creating Related
          Instruments; 
          <br /> (b) marketing Related Instruments; 
          <br /> (c) transacting in Related Instruments in any form whatsoever.
        </p>
        <p className="font-bold">2. Term</p>
        <p>
          2.1 These Terms of Use commence on the date on which the User
          indicates on the Cambodia Carbon Registry website that the User agrees
          with and accepts the Terms of Use (Commencement Date) and shall
          continue in effect until terminated in accordance with Clause 14 (End
          Date).
        </p>
        <p className="font-bold">3. Services</p>
        <p>
          3.1 The MoE, through the Cambodia Carbon Registry, provides an
          electronic platform to list GHG ER projects that follow the applicable
          protocols and standards for the relevant programs and record the
          issuance, transfer, retirement, and cancellation of carbon credits
          within the Cambodia Carbon Registry.
        </p>
        <p>
          3.2 The Cambodia Carbon Registry lists GHG ER projects and issues
          carbon credits in accordance with the Program Rules and Requirements
          of each program it administers. Accordingly, before a GHG ER project
          can be listed or carbon credits issued, the User must provide the MoE
          with appropriate documentation for its approval in accordance with the
          procedures set out by the MoE.
        </p>
        <p className="font-bold">4. Opening an Account</p>
        <p>
          4.1 A User may request that the MoE open a Cambodia Carbon Registry
          Account for that User in accordance with the procedures set out by the
          MoE.
        </p>
        <p>
          4.2 The MoE will only open a Cambodia Carbon Registry Account for a
          User if:  (a) the User is not an individual (being a natural person); 
          (b) the User has indicated its acceptance of these Terms of Use; and 
          (c) the User has provided sufficient identification and other
          information to satisfy any relevant Know-Your-Client (KYC) and/or
          other compliance screening and background check requirements in
          accordance with the procedures set out by the MoE.
        </p>
        <p className="font-bold">5. Listing a Project</p>
        <p>
          5.1 Once the User has opened a Cambodia Carbon Registry Account, the
          User may request that the MoE list a GHG ER project in accordance with
          the procedures set out by the MoE, including any Program Rules and
          Requirements. 5.2 The MoE will require any User who intends to list a
          GHG ER project to provide all documentation and information as
          required by the relevant Program Rules and Requirements.
        </p>
        <p className="font-bold">6. Issuance of Carbon Credits</p>
        <p>
          6.1 A User may request that the MoE issue carbon credits to its
          Cambodia Carbon Registry Account in accordance with the relevant
          Program Rules and Requirements.
        </p>
        <p>
          6.2 The MoE will require any User who intends to issue carbon credits
          in the Cambodia Carbon Registry to provide all documentation,
          attestations, and information as required by the relevant Program
          Rules and Requirements.
        </p>
        <p className="font-bold">7. Recording the Transfer of Carbon Credits</p>
        <p>
          7.1 Upon receiving notification from the User or a Financial Market
          Settlement System that there has been an erroneous or fraudulent
          dealing related to carbon credits in the Cambodia Carbon Registry, the
          MoE may, at its total discretion, reverse the transaction or movement
          of carbon credits or remove any carbon credits being held in a User's
          Cambodia Carbon Registry Account.
        </p>
        <p className="font-bold">
          8. Cancellation and Retirement of Carbon Credits
        </p>
        <p>
          8.1 The User may request that the MoE cancel or retire carbon credits
          in accordance with the relevant Program Rules and Requirements and the
          procedures set out by the MoE.
        </p>
        <p>
          8.2 Upon cancellation or retirement: 
          <br /> (a) all legal and beneficial title and interests in such carbon
          credits will be extinguished; and 
          <br /> (b) neither the MoE, the User, nor any other person with Legal
          or Beneficial Ownership Rights will have any further rights to take
          the benefit of such carbon credits or the underlying Environmental
          Benefits corresponding to such carbon credits.
        </p>
        <p className="font-bold">9. Legal Title to Carbon Credits</p>
        <p>
          9.1 Notwithstanding anything in Clause 6, the User acknowledges and
          agrees that the MoE does not guarantee legal title to the carbon
          credits, and the User relies on any content obtained through the
          Cambodia Carbon Registry at its own risk.{" "}
        </p>
        <p className="font-bold">10. Fees and Charges</p>
        <p>
          10.1 Fees and charges payable for use of the Cambodia Carbon Registry
          are contained in each Program's Fee Schedule, as updated from time to
          time.
        </p>
        <p className="font-bold">
          11. Limitation of Liability and Indemnification{" "}
        </p>
        <p>
          11.1 The User assumes full responsibility and risk of loss resulting
          from its use of the Cambodia Carbon Registry and will have no claim
          whatsoever against the MoE or its independent contractors, other than
          where liabilities are determined by final adjudication to have been
          caused by the MoE's or its independent contractors' fraud, gross
          negligence, or willful misconduct.{" "}
        </p>
        <p className="font-bold">12. Termination and Suspension</p>
        <p>
          12.1 The MoE may terminate these Terms of Use by giving not less than
          ten (10) Business Days' notice in writing to the User, except in the
          event of a material breach of the Terms of Use, in which case the MoE
          may terminate these Terms of Use immediately.
        </p>
        <p className="font-bold">13. Force Majeure</p>
        <p>
          13.1 To the extent the MoE is prevented by Force Majeure from fully
          performing any of its obligations under these Terms of Use, the MoE
          shall be excused from the performance of such obligations for as long
          as the Force Majeure event is continuing. Definitions Agent: Any User
          of the Cambodia Carbon Registry who does so in the capacity as a
          broker, agent, or representative of any kind on behalf of a Principal
          for the purposes of utilizing the Cambodia Carbon Registry services.
          Carbon Credit: A unit issued by, and held in the Cambodia Carbon
          Registry representing the right of an accountholder in whose account
          the unit is recorded to claim the achievement represented by the unit.
          GHG ER Project: A project that reduces or removes greenhouse gas
          emissions in accordance with the applicable Program Rules and
          Requirements. Program Rules and Requirements: Those rules and
          requirements adopted by the MoE and set forth in the Program Rules and
          Requirements for the relevant programs administered by the Cambodia
          Carbon Registry.
        </p>
      </div>
    </div>
  )
}
